var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectPolicyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41026",
    "data-name": "Group 41026",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 473.13,
    height: 460.481,
    viewBox: "0 0 473.13 460.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-10, .cls-12, .cls-13, .cls-14, .cls-7, .cls-8 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #4eb2a2;\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: 0.7;\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clip-path-3);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-12, .cls-13, .cls-14, .cls-7 {\r\n        stroke: #012d35;\r\n      }\r\n\r\n      .cls-10, .cls-12, .cls-13, .cls-7, .cls-8 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-8 {\r\n        stroke: #c3c3c3;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #a6a6a6;\r\n      }\r\n\r\n      .cls-10 {\r\n        stroke: #a6a6a6;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #012d35;\r\n      }\r\n\r\n      .cls-12 {\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-13 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-14 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7840",
    "data-name": "Rectangle 7840",
    className: "cls-1",
    width: 473.13,
    height: 460.481
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7682",
    "data-name": "Rectangle 7682",
    className: "cls-1",
    width: 446.498,
    height: 439.615,
    transform: "translate(19.039 19.679)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41025",
    "data-name": "Group 41025",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41024",
    "data-name": "Group 41024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41023",
    "data-name": "Group 41023",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40719",
    "data-name": "Path 40719",
    className: "cls-3",
    d: "M464.13,233.63c-4.93,41.8-24,90.41-62.14,112.73C344.4,380.11,349.22,432,236.8,454.56a231.258,231.258,0,0,1-49.84,4.71,194.608,194.608,0,0,1-24.47-2C91.04,446.84,42.96,397.18,25.32,337.22,2.11,258.38,48.46,206.72,79.18,175.66s53.23-128,163.57-151a223.756,223.756,0,0,1,51.23-4.94c39.26,1,82.08,13.86,111.71,40.76q3.33,3,6.5,6.28c41.18,42.29,58.68,109.88,51.94,166.87"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41022",
    "data-name": "Group 41022",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41021",
    "data-name": "Group 41021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41020",
    "data-name": "Group 41020",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40720",
    "data-name": "Path 40720",
    className: "cls-6",
    d: "M464.13,233.63c-4.93,41.8-24,90.41-62.14,112.73C344.4,380.11,349.22,432,236.8,454.56a231.258,231.258,0,0,1-49.84,4.71,194.608,194.608,0,0,1-24.47-2C91.04,446.84,42.96,397.18,25.32,337.22,2.11,258.38,48.46,206.72,79.18,175.66s53.23-128,163.57-151a223.756,223.756,0,0,1,51.23-4.94c39.26,1,82.08,13.86,111.71,40.76q3.33,3,6.5,6.28c41.18,42.29,58.68,109.88,51.94,166.87"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    className: "cls-7",
    x2: 451.38,
    transform: "translate(21.25 445.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40721",
    "data-name": "Path 40721",
    className: "cls-8",
    d: "M345.66,55.12h38.1s3.65-11-2.93-15-6.58,1.46-11.7-.74c-4.22-1.81-5-5.25-6.2-8.89-.13-.42-.27-.84-.42-1.25a16.631,16.631,0,0,0-1.58-3.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40722",
    "data-name": "Path 40722",
    className: "cls-8",
    d: "M356.45,21.26c-9.54-7-25.33-4.37-25.33,10.47,0,3.65-8.78,0-12.07,4.75s.37,7.68-4,9.14-4.75-2.19-10.24-1.83-4.75,5.48-6.58,6.95-1.82.73-5.84,1.09-4.76,3.29-4.76,3.29h51.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40723",
    "data-name": "Path 40723",
    className: "cls-8",
    d: "M366.26,51.12a10.74,10.74,0,0,0-2.9-10.68c-4.89-4.52-10-2-11.41,0s-1.45,5.8-3.8,6.16-1.81-4-6.88-2.9-3.08,6.16-5.43,7.24-2.35-2.89-5.61-1.63-3.08,3.62-3.08,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40724",
    "data-name": "Path 40724",
    className: "cls-8",
    d: "M340.25,38.82a9.17,9.17,0,0,0-9.27-.8c-5.24,2.42-2.82,7.46-5.24,8.67s-3.63-.21-6.65,1.21-2.83,3.42-2.83,3.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40725",
    "data-name": "Path 40725",
    className: "cls-8",
    d: "M85.53,123.04a5.139,5.139,0,0,0-2.91-.62c-3.15.21-2.73,3.15-3.78,4s-1,.42-3.35.63a2.861,2.861,0,0,0-2.73,1.88h55.17s1.36-4.07-.08-6.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40726",
    "data-name": "Path 40726",
    className: "cls-8",
    d: "M126.27,120.32c-3.77-2.3-3.77.84-6.71-.42-2.43-1-2.88-3-3.56-5.1l-.24-.72c-3.19-8.86-18-9.47-18,1.42,0,2.1-5,0-6.92,2.73s.21,4.4-2.31,5.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40727",
    "data-name": "Path 40727",
    className: "cls-8",
    d: "M117.91,126.63a6.172,6.172,0,0,0-1.66-6.13c-2.81-2.6-5.72-1.14-6.55,0s-.83,3.32-2.18,3.53-1-2.28-3.95-1.66-1.76,3.53-3.12,4.16-1.35-1.67-3.22-.94-1.76,2.13-1.76,2.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40728",
    "data-name": "Path 40728",
    className: "cls-8",
    d: "M102.99,119.57a5.26,5.26,0,0,0-5.32-.46c-3,1.39-1.62,4.28-3,5s-2.08-.11-3.82.7-1.62,2-1.62,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40729",
    "data-name": "Path 40729",
    className: "cls-8",
    d: "M214.53,27.24a5.086,5.086,0,0,0-2.9-.62c-3.15.21-2.73,3.15-3.78,4s-1.05.42-3.36.62a2.86,2.86,0,0,0-2.72,1.89h55.17s1.36-4.07-.08-6.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40730",
    "data-name": "Path 40730",
    className: "cls-8",
    d: "M255.22,24.52c-3.77-2.31-3.77.84-6.71-.42-2.43-1-2.88-3-3.56-5.1l-.24-.72c-3.19-8.86-18-9.48-18,1.42,0,2.09-5,0-6.92,2.72s.21,4.41-2.31,5.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40731",
    "data-name": "Path 40731",
    className: "cls-8",
    d: "M246.86,30.83a6.162,6.162,0,0,0-1.67-6.11c-2.8-2.6-5.71-1.15-6.54,0s-.83,3.32-2.18,3.53-1-2.29-3.95-1.66-1.77,3.53-3.12,4.15-1.35-1.66-3.22-.93-1.77,2.08-1.77,2.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40732",
    "data-name": "Path 40732",
    className: "cls-8",
    d: "M231.93,23.77a5.26,5.26,0,0,0-5.32-.46c-3,1.38-1.62,4.28-3,5s-2.09-.12-3.82.69-1.62,2-1.62,2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7683",
    "data-name": "Rectangle 7683",
    className: "cls-9",
    width: 217.79,
    height: 367.01,
    transform: "translate(213.83 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7684",
    "data-name": "Rectangle 7684",
    className: "cls-10",
    width: 217.79,
    height: 367.01,
    transform: "translate(213.83 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7685",
    "data-name": "Rectangle 7685",
    className: "cls-6",
    width: 125.4,
    height: 367.01,
    transform: "translate(306.22 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7686",
    "data-name": "Rectangle 7686",
    className: "cls-10",
    width: 125.4,
    height: 367.01,
    transform: "translate(306.22 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7687",
    "data-name": "Rectangle 7687",
    className: "cls-6",
    width: 96.29,
    height: 367.01,
    transform: "translate(320.77 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7688",
    "data-name": "Rectangle 7688",
    className: "cls-10",
    width: 96.29,
    height: 367.01,
    transform: "translate(320.77 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7689",
    "data-name": "Rectangle 7689",
    className: "cls-9",
    width: 125.4,
    height: 25.14,
    transform: "translate(306.22 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7690",
    "data-name": "Rectangle 7690",
    className: "cls-10",
    width: 125.4,
    height: 25.14,
    transform: "translate(306.22 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7691",
    "data-name": "Rectangle 7691",
    className: "cls-6",
    width: 60.92,
    height: 45.11,
    transform: "translate(338.46 400.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7692",
    "data-name": "Rectangle 7692",
    className: "cls-10",
    width: 60.92,
    height: 45.11,
    transform: "translate(338.46 400.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7693",
    "data-name": "Rectangle 7693",
    className: "cls-6",
    width: 30.46,
    height: 45.11,
    transform: "translate(368.92 400.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7694",
    "data-name": "Rectangle 7694",
    className: "cls-10",
    width: 30.46,
    height: 45.11,
    transform: "translate(368.92 400.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7695",
    "data-name": "Rectangle 7695",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7696",
    "data-name": "Rectangle 7696",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7697",
    "data-name": "Rectangle 7697",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7698",
    "data-name": "Rectangle 7698",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7699",
    "data-name": "Rectangle 7699",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7700",
    "data-name": "Rectangle 7700",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7701",
    "data-name": "Rectangle 7701",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7702",
    "data-name": "Rectangle 7702",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7703",
    "data-name": "Rectangle 7703",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7704",
    "data-name": "Rectangle 7704",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7705",
    "data-name": "Rectangle 7705",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7706",
    "data-name": "Rectangle 7706",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7707",
    "data-name": "Rectangle 7707",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7708",
    "data-name": "Rectangle 7708",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7709",
    "data-name": "Rectangle 7709",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7710",
    "data-name": "Rectangle 7710",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7711",
    "data-name": "Rectangle 7711",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7712",
    "data-name": "Rectangle 7712",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7713",
    "data-name": "Rectangle 7713",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7714",
    "data-name": "Rectangle 7714",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7715",
    "data-name": "Rectangle 7715",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7716",
    "data-name": "Rectangle 7716",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7717",
    "data-name": "Rectangle 7717",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7718",
    "data-name": "Rectangle 7718",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7719",
    "data-name": "Rectangle 7719",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7720",
    "data-name": "Rectangle 7720",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7721",
    "data-name": "Rectangle 7721",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7722",
    "data-name": "Rectangle 7722",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7723",
    "data-name": "Rectangle 7723",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7724",
    "data-name": "Rectangle 7724",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7725",
    "data-name": "Rectangle 7725",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7726",
    "data-name": "Rectangle 7726",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7727",
    "data-name": "Rectangle 7727",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7728",
    "data-name": "Rectangle 7728",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7729",
    "data-name": "Rectangle 7729",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7730",
    "data-name": "Rectangle 7730",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7731",
    "data-name": "Rectangle 7731",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7732",
    "data-name": "Rectangle 7732",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7733",
    "data-name": "Rectangle 7733",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7734",
    "data-name": "Rectangle 7734",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7735",
    "data-name": "Rectangle 7735",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7736",
    "data-name": "Rectangle 7736",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(228.3 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7737",
    "data-name": "Rectangle 7737",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7738",
    "data-name": "Rectangle 7738",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(228.3 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7739",
    "data-name": "Rectangle 7739",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7740",
    "data-name": "Rectangle 7740",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(267.82 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7741",
    "data-name": "Rectangle 7741",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7742",
    "data-name": "Rectangle 7742",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(267.82 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7743",
    "data-name": "Rectangle 7743",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7744",
    "data-name": "Rectangle 7744",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7745",
    "data-name": "Rectangle 7745",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7746",
    "data-name": "Rectangle 7746",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7747",
    "data-name": "Rectangle 7747",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7748",
    "data-name": "Rectangle 7748",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7749",
    "data-name": "Rectangle 7749",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7750",
    "data-name": "Rectangle 7750",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7751",
    "data-name": "Rectangle 7751",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7752",
    "data-name": "Rectangle 7752",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 119.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7753",
    "data-name": "Rectangle 7753",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7754",
    "data-name": "Rectangle 7754",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 112.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7755",
    "data-name": "Rectangle 7755",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7756",
    "data-name": "Rectangle 7756",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7757",
    "data-name": "Rectangle 7757",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7758",
    "data-name": "Rectangle 7758",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7759",
    "data-name": "Rectangle 7759",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7760",
    "data-name": "Rectangle 7760",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7761",
    "data-name": "Rectangle 7761",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7762",
    "data-name": "Rectangle 7762",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7763",
    "data-name": "Rectangle 7763",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7764",
    "data-name": "Rectangle 7764",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 168.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7765",
    "data-name": "Rectangle 7765",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7766",
    "data-name": "Rectangle 7766",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 160.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7767",
    "data-name": "Rectangle 7767",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7768",
    "data-name": "Rectangle 7768",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7769",
    "data-name": "Rectangle 7769",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7770",
    "data-name": "Rectangle 7770",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7771",
    "data-name": "Rectangle 7771",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7772",
    "data-name": "Rectangle 7772",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7773",
    "data-name": "Rectangle 7773",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7774",
    "data-name": "Rectangle 7774",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7775",
    "data-name": "Rectangle 7775",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7776",
    "data-name": "Rectangle 7776",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 216.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7777",
    "data-name": "Rectangle 7777",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7778",
    "data-name": "Rectangle 7778",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 209.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7779",
    "data-name": "Rectangle 7779",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7780",
    "data-name": "Rectangle 7780",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7781",
    "data-name": "Rectangle 7781",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7782",
    "data-name": "Rectangle 7782",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7783",
    "data-name": "Rectangle 7783",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7784",
    "data-name": "Rectangle 7784",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7785",
    "data-name": "Rectangle 7785",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7786",
    "data-name": "Rectangle 7786",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7787",
    "data-name": "Rectangle 7787",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7788",
    "data-name": "Rectangle 7788",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 264.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7789",
    "data-name": "Rectangle 7789",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7790",
    "data-name": "Rectangle 7790",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 257.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7791",
    "data-name": "Rectangle 7791",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7792",
    "data-name": "Rectangle 7792",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7793",
    "data-name": "Rectangle 7793",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7794",
    "data-name": "Rectangle 7794",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7795",
    "data-name": "Rectangle 7795",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7796",
    "data-name": "Rectangle 7796",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7797",
    "data-name": "Rectangle 7797",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7798",
    "data-name": "Rectangle 7798",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7799",
    "data-name": "Rectangle 7799",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7800",
    "data-name": "Rectangle 7800",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 312.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7801",
    "data-name": "Rectangle 7801",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7802",
    "data-name": "Rectangle 7802",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 305.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7803",
    "data-name": "Rectangle 7803",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7804",
    "data-name": "Rectangle 7804",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(316.34 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7805",
    "data-name": "Rectangle 7805",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7806",
    "data-name": "Rectangle 7806",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(316.34 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7807",
    "data-name": "Rectangle 7807",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7808",
    "data-name": "Rectangle 7808",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(355.87 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7809",
    "data-name": "Rectangle 7809",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7810",
    "data-name": "Rectangle 7810",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(355.87 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7811",
    "data-name": "Rectangle 7811",
    className: "cls-6",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7812",
    "data-name": "Rectangle 7812",
    className: "cls-10",
    width: 27.65,
    height: 25.11,
    transform: "translate(395.39 360.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7813",
    "data-name": "Rectangle 7813",
    className: "cls-6",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7814",
    "data-name": "Rectangle 7814",
    className: "cls-10",
    width: 27.65,
    height: 10.92,
    transform: "translate(395.39 353.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7815",
    "data-name": "Rectangle 7815",
    className: "cls-6",
    width: 107.7,
    height: 13.66,
    transform: "translate(314.99 400.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7816",
    "data-name": "Rectangle 7816",
    className: "cls-10",
    width: 107.7,
    height: 13.66,
    transform: "translate(314.99 400.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7817",
    "data-name": "Rectangle 7817",
    className: "cls-6",
    width: 107.7,
    height: 13.66,
    transform: "translate(314.99 396.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7818",
    "data-name": "Rectangle 7818",
    className: "cls-10",
    width: 107.7,
    height: 13.66,
    transform: "translate(314.99 396.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7819",
    "data-name": "Rectangle 7819",
    className: "cls-9",
    width: 58.67,
    height: 36.17,
    transform: "translate(213.71 59.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7820",
    "data-name": "Rectangle 7820",
    className: "cls-10",
    width: 58.67,
    height: 36.17,
    transform: "translate(213.71 59.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7821",
    "data-name": "Rectangle 7821",
    className: "cls-6",
    width: 20.3,
    height: 36.17,
    transform: "translate(252.08 59.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7822",
    "data-name": "Rectangle 7822",
    className: "cls-10",
    width: 20.3,
    height: 36.17,
    transform: "translate(252.08 59.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7823",
    "data-name": "Rectangle 7823",
    className: "cls-6",
    width: 24.11,
    height: 27.33,
    transform: "translate(396.97 68.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7824",
    "data-name": "Rectangle 7824",
    className: "cls-10",
    width: 24.11,
    height: 27.33,
    transform: "translate(396.97 68.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7825",
    "data-name": "Rectangle 7825",
    className: "cls-9",
    width: 24.11,
    height: 27.33,
    transform: "translate(385.82 68.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7826",
    "data-name": "Rectangle 7826",
    className: "cls-10",
    width: 24.11,
    height: 27.33,
    transform: "translate(385.82 68.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7827",
    "data-name": "Rectangle 7827",
    className: "cls-6",
    width: 228.4,
    height: 17.29,
    transform: "translate(208.53 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7828",
    "data-name": "Rectangle 7828",
    className: "cls-10",
    width: 228.4,
    height: 17.29,
    transform: "translate(208.53 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7829",
    "data-name": "Rectangle 7829",
    className: "cls-6",
    width: 136.58,
    height: 17.29,
    transform: "translate(300.34 78.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7830",
    "data-name": "Rectangle 7830",
    className: "cls-10",
    width: 136.58,
    height: 17.29,
    transform: "translate(300.34 78.81)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    className: "cls-10",
    y2: 7.26,
    transform: "translate(306.22 78.81)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    className: "cls-10",
    y2: 7.26,
    transform: "translate(309.95 78.81)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    className: "cls-10",
    y2: 5.54,
    transform: "translate(309.95 88.03)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    className: "cls-10",
    y2: 7.26,
    transform: "translate(313.69 78.81)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    className: "cls-10",
    y2: 5.14,
    transform: "translate(313.69 88.34)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    className: "cls-10",
    y2: 3.24,
    transform: "translate(317.18 88.34)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    className: "cls-10",
    y2: 7.26,
    transform: "translate(317.43 78.81)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    className: "cls-10",
    y2: 1.84,
    transform: "translate(321.66 84.23)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    className: "cls-10",
    y2: 4.13,
    transform: "translate(321.91 78.81)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    className: "cls-10",
    y2: 4.3,
    transform: "translate(306.22 87.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40733",
    "data-name": "Path 40733",
    className: "cls-11",
    d: "M22.36,142.07c4.26,1.86,14.69,1.62,14.7,1.62s-2.24-6.83-2.44-7.24c-2.29-4.79-9.53-12.69-15.41-11.9a7,7,0,0,0-5.863,7.977,7.152,7.152,0,0,0,.183.843c1,4.08,5.2,7.11,8.83,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40734",
    "data-name": "Path 40734",
    className: "cls-11",
    d: "M25.96,172.28c4.42.64,13.73-2.06,14.47-2.28a125.443,125.443,0,0,0,5.64,15.63c1.28,3,2.67,5.91,4.09,8.84-.85-1.24-1.62-2.35-1.74-2.49-3.47-4-12.54-9.73-18-7.4a7,7,0,0,0-3.51,9.256,6.926,6.926,0,0,0,.39.744c2,3.67,6.86,5.49,10.78,6.06s12-1.56,14.07-2.15c.56,1.12,1.1,2.24,1.66,3.36,2.7,5.37,5.41,10.71,7.91,16,.88,1.88,1.68,3.76,2.49,5.64-.75-1.11-1.4-2-1.51-2.16-3.47-4-12.54-9.73-18-7.4a7,7,0,0,0-3.51,9.256,6.924,6.924,0,0,0,.39.744c2,3.67,6.86,5.49,10.78,6.06s11.17-1.35,13.67-2.04c.77,2,1.54,3.9,2.2,5.82.42,1.32.91,2.57,1.26,3.92l1.1,4c.61,2.54,1.26,5.16,1.79,7.65.38,1.73.71,3.38,1.05,5.05-.85-1.88-2.61-5.52-2.79-5.8-2.82-4.5-10.92-11.52-16.68-10.05a7,7,0,0,0-4.59,9.4c1.44,3.94,5.95,6.47,9.74,7.63,4.17,1.28,13.41.11,14.56,0,.56,2.76,1.07,5.45,1.51,8,.33,1.88.64,3.69.91,5.43h3.7c-.35-1.94-.73-4-1.15-6.08-.55-2.81-1.19-5.79-1.89-8.85a76.856,76.856,0,0,0,8.13-3.82c3,3.29,10.84,7.14,11.84,7.63-1.06,2.61-2.11,5.14-3.15,7.51-.54,1.25-1.07,2.44-1.6,3.61h3.91c.31-.74.62-1.47.93-2.24,1.09-2.65,2.2-5.49,3.32-8.43,1.11.24,10.26,2.09,14.52,1.13,3.87-.87,8.55-3.06,10.28-6.88a7,7,0,0,0-3.88-9.72c-5.63-1.89-14.23,4.5-17.38,8.77-.19.26-1.9,3.21-3,5.1.45-1.2.9-2.36,1.34-3.61.9-2.45,1.73-4.92,2.62-7.57.39-1.3.79-2.61,1.18-3.94s.7-2.73,1.06-4.11c.77-3.22,1.39-6.52,1.94-9.85,2.14.78,9.81,3.45,13.78,3.17s8.91-1.73,11.2-5.25a7,7,0,0,0-2.26-10.28c-5.28-2.73-14.75,2.3-18.51,6-.23.23-2.63,3.22-3.92,4.89.32-2,.64-4,.9-6.05.73-5.89,1.28-11.88,1.87-17.85.17-1.83.37-3.65.57-5.47.76.29,9.8,3.65,14.25,3.34,3.95-.28,8.91-1.73,11.2-5.25a7,7,0,0,0-1.68-9.756,6.9,6.9,0,0,0-.68-.424c-5.28-2.72-14.75,2.3-18.51,6-.29.28-3.73,4.59-4.55,5.73.42-4,.88-8,1.5-11.94a124.91,124.91,0,0,1,3.42-15.69c.36.14,9.78,3.69,14.34,3.37,3.95-.27,8.91-1.73,11.2-5.24a7,7,0,0,0-1.768-9.74,7.2,7.2,0,0,0-.632-.39c-5.28-2.72-14.74,2.3-18.51,6-.29.3-4,4.93-4.6,5.82.08-.3.14-.62.23-.91a91.49,91.49,0,0,1,6.22-14.85c1.35-2.65,2.79-5.1,4.25-7.45,1.68.84,9.44,4.6,13.57,4.77,4,.16,9.05-.74,11.71-4a7,7,0,0,0-1.23-10.4c-5-3.28-14.91.67-19.06,4-.23.18-2.32,2.27-3.82,3.8.67-1,1.35-2.15,2-3.14,2.49-3.75,5-7,7.24-9.9,1.29-1.63,2.48-3.08,3.62-4.42,2.09,0,10.49-.29,14.17-2s7.69-4.83,8.56-8.93a7,7,0,0,0-5.067-8.5,7.236,7.236,0,0,0-.813-.155c-5.91-.63-12.93,7.46-15.09,12.31-.19.42-2.35,7.31-2.24,7.31h.12c-1.12,1.27-2.3,2.65-3.56,4.17-2.31,2.84-4.9,6.07-7.47,9.78a123.464,123.464,0,0,0-7.75,12.34,90.856,90.856,0,0,0-6.62,14.9l-.06.19c0-1.74,0-6.61-.09-7-.68-5.27-5.09-15-10.94-16.11a7,7,0,0,0-8.027,5.794,7.207,7.207,0,0,0-.083.816c-.34,4.18,2.69,8.37,5.65,11,3.33,3,12.58,5.86,13.32,6.08a125.25,125.25,0,0,0-3.91,16.15c-.57,3.18-1,6.4-1.47,9.63a22.885,22.885,0,0,0-.08-3c-.68-5.26-5.09-15-10.94-16.11a7,7,0,0,0-8.019,5.8,7.241,7.241,0,0,0-.081.805c-.35,4.19,2.68,8.37,5.64,11s10.84,5.3,12.92,6c-.15,1.24-.32,2.48-.47,3.73-.71,6-1.39,11.91-2.25,17.73-.29,2-.66,4.06-1,6.07,0-1.33-.05-2.46-.07-2.63-.68-5.26-5.09-15-10.93-16.11a7,7,0,0,0-8.12,6.61c-.34,4.18,2.69,8.37,5.65,11s10.08,5,12.55,5.84c-.44,2-.87,4.1-1.38,6.06-.38,1.34-.65,2.65-1.11,4s-.84,2.61-1.26,3.9c-.89,2.46-1.8,5-2.73,7.37-.63,1.65-1.27,3.22-1.91,4.79.33-2,.87-6,.88-6.38a27.349,27.349,0,0,0-3.66-13.28,9.148,9.148,0,0,0-.1-1.56,7,7,0,0,0-7.757-6.15,7.085,7.085,0,0,0-.843.15c-5.74,1.53-9.38,11.61-9.65,16.91,0,.31.18,3.72.35,5.87-.29-1.25-.56-2.47-.87-3.75-.6-2.54-1.28-5-2-7.76-.4-1.3-.79-2.61-1.19-3.93s-.93-2.67-1.39-4c-1.14-3.1-2.44-6.2-3.82-9.28,2.22-.53,10.09-2.54,13.25-5s6.48-6.36,6.45-10.56a7,7,0,0,0-7.6-7.2c-5.91.64-11,10.05-12.11,15.25-.06.33-.41,4.14-.56,6.24-.85-1.85-1.68-3.7-2.6-5.54-2.64-5.32-5.47-10.62-8.28-15.92-.86-1.62-1.7-3.25-2.55-4.87.8-.18,10.2-2.37,13.73-5.08,3.15-2.41,6.48-6.36,6.45-10.55a7,7,0,0,0-6.771-7.222,7.218,7.218,0,0,0-.819.022c-5.91.64-11,10-12.11,15.25-.08.39-.57,5.88-.63,7.28-1.86-3.58-3.68-7.17-5.34-10.78a124.424,124.424,0,0,1-5.8-15c.37-.08,10.19-2.31,13.82-5.09,3.14-2.41,6.48-6.36,6.45-10.56a7,7,0,0,0-7.6-7.2c-5.9.65-11,10.06-12.1,15.25-.09.41-.62,6.32-.64,7.4-.09-.3-.22-.6-.3-.89a90.22,90.22,0,0,1-3-15.82c-.33-2.95-.48-5.79-.57-8.56,1.87-.22,10.42-1.36,13.95-3.5s7.14-5.61,7.57-9.79a7,7,0,0,0-5.926-7.93,6.886,6.886,0,0,0-.824-.07c-6,0-12.08,8.78-13.71,13.83-.09.28-.69,3.17-1.09,5.28,0-1.25-.07-2.54-.06-3.74,0-4.49.29-8.6.57-12.25.18-2.07.38-3.93.59-5.68,1.72-1.18,8.59-6,10.7-9.5s3.75-8.27,2.21-12.17a7,7,0,0,0-9.68-4c-5.32,2.78-6.68,13.41-5.83,18.64.08.45,2.07,7.39,2.16,7.33l.1-.07c-.23,1.68-.46,3.48-.67,5.45-.36,3.64-.74,7.76-.84,12.27a123.223,123.223,0,0,0,.4,14.57,90.932,90.932,0,0,0,2.7,16.08.252.252,0,0,0,.06.19c-.94-1.47-3.69-5.49-3.94-5.78-3.47-4-12.54-9.72-18-7.4a7,7,0,0,0-3.11,10c1.96,3.67,6.8,5.5,10.72,6.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40735",
    "data-name": "Path 40735",
    className: "cls-11",
    d: "M127.86,144.36c.09.06,1.89-6.93,2-7.39.73-5.25-.95-15.84-6.3-18.42a7,7,0,0,0-9.272,3.468,6.872,6.872,0,0,0-.3.772c-1.43,3.94.39,8.77,2.54,12.1,2.49,3.91,11.32,9.46,11.33,9.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40736",
    "data-name": "Path 40736",
    className: "cls-11",
    d: "M283.71,375.58c2.36,1,8.13.9,8.14.9s-1.24-3.78-1.35-4c-1.27-2.65-5.28-7-8.54-6.59a3.889,3.889,0,0,0-3.12,4.88c.54,2.25,2.86,3.95,4.87,4.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40737",
    "data-name": "Path 40737",
    className: "cls-11",
    d: "M285.7,392.31c2.45.35,7.61-1.14,8-1.26a69.147,69.147,0,0,0,3.12,8.65c.71,1.64,1.48,3.27,2.26,4.9a13.183,13.183,0,0,0-1-1.38c-1.92-2.22-6.94-5.39-10-4.1a3.89,3.89,0,0,0-1.928,5.152,3.765,3.765,0,0,0,.2.378c1.12,2,3.8,3,6,3.36s6.62-.87,7.79-1.19l.92,1.86c1.49,3,3,5.93,4.38,8.88.49,1,.93,2.08,1.38,3.12-.42-.61-.78-1.13-.84-1.2-1.92-2.22-6.94-5.38-10-4.1a3.9,3.9,0,0,0-1.73,5.53c1.12,2,3.8,3.05,6,3.36s6.2-.75,7.58-1.13c.43,1.08.86,2.16,1.22,3.22.23.73.51,1.42.7,2.17s.41,1.47.61,2.19c.34,1.41.69,2.85,1,4.23.21,1,.39,1.88.58,2.8-.47-1-1.44-3-1.54-3.21-1.57-2.49-6.05-6.38-9.24-5.57a3.9,3.9,0,0,0-2.673,4.824,4,4,0,0,0,.133.386c.79,2.18,3.29,3.59,5.39,4.23,2.31.7,7.43.06,8.06,0,.31,1.53.59,3,.84,4.43q.27,1.575.51,3h2c-.19-1.07-.4-2.19-.63-3.37-.31-1.55-.67-3.2-1.05-4.9a39.349,39.349,0,0,0,4.5-2.12c1.69,1.83,6,4,6.56,4.23-.59,1.45-1.17,2.85-1.75,4.16l-.88,2h2.16c.18-.41.35-.81.52-1.24.6-1.47,1.22-3,1.83-4.67.62.13,5.69,1.16,8.05.63,2.14-.49,4.73-1.7,5.69-3.81a3.9,3.9,0,0,0-1.766-5.225,3.83,3.83,0,0,0-.384-.165c-3.12-1-7.88,2.5-9.62,4.86-.11.14-1,1.78-1.64,2.82.25-.66.5-1.3.75-2,.5-1.36.95-2.73,1.45-4.2.21-.72.43-1.44.65-2.18s.39-1.51.59-2.28c.42-1.78.76-3.6,1.07-5.45,1.19.43,5.43,1.91,7.63,1.76s4.94-1,6.21-2.91a3.889,3.889,0,0,0-.954-5.418,3.718,3.718,0,0,0-.356-.222c-2.93-1.51-8.17,1.27-10.25,3.34-.13.13-1.46,1.79-2.17,2.71.17-1.11.35-2.22.49-3.35.41-3.26.72-6.58,1-9.89.1-1,.21-2,.31-3,.43.16,5.43,2,7.9,1.85,2.19-.15,4.93-1,6.2-2.9a3.9,3.9,0,0,0-.959-5.431,3.741,3.741,0,0,0-.351-.219c-2.92-1.5-8.17,1.28-10.25,3.35-.16.16-2.06,2.54-2.52,3.17.24-2.22.49-4.44.83-6.61a69.889,69.889,0,0,1,1.9-8.69c.19.08,5.41,2.05,7.94,1.87,2.19-.15,4.93-1,6.2-2.91a3.889,3.889,0,0,0-.954-5.418,3.717,3.717,0,0,0-.356-.222c-2.92-1.51-8.17,1.27-10.25,3.34-.16.17-2.21,2.73-2.55,3.22.05-.16.08-.34.13-.5a49.6,49.6,0,0,1,3.44-8.22c.75-1.47,1.55-2.83,2.35-4.13.94.47,5.23,2.55,7.52,2.64s5-.41,6.48-2.2a3.89,3.89,0,0,0-.339-5.491,3.7,3.7,0,0,0-.341-.269c-2.74-1.82-8.25.37-10.55,2.2-.13.1-1.28,1.25-2.12,2.1.38-.58.75-1.19,1.12-1.74,1.37-2.07,2.76-3.88,4-5.48.71-.9,1.37-1.7,2-2.45,1.16,0,5.81-.16,7.85-1.11s4.26-2.68,4.74-4.95a3.89,3.89,0,0,0-2.842-4.711,3.951,3.951,0,0,0-.418-.079c-3.27-.36-7.16,4.13-8.35,6.81-.11.23-1.31,4.05-1.25,4.05h.07c-.62.7-1.27,1.46-2,2.31-1.28,1.57-2.71,3.36-4.14,5.41a68.8,68.8,0,0,0-4.29,6.83,51.378,51.378,0,0,0-3.67,8.25.339.339,0,0,1,0,.11v-3.87c-.38-2.91-2.82-8.32-6.05-8.92a3.9,3.9,0,0,0-4.458,3.248,4.056,4.056,0,0,0-.042.412c-.19,2.32,1.49,4.64,3.13,6.1,1.85,1.65,7,3.24,7.38,3.37a70.181,70.181,0,0,0-2.17,8.94c-.31,1.76-.57,3.54-.81,5.33v-1.68c-.38-2.91-2.82-8.32-6.06-8.92a3.89,3.89,0,0,0-4.447,3.238,3.992,3.992,0,0,0-.043.422c-.19,2.32,1.49,4.63,3.12,6.1s6,2.93,7.16,3.3c-.09.69-.18,1.37-.26,2.06-.39,3.3-.77,6.6-1.25,9.82-.16,1.14-.37,2.25-.57,3.36v-1.45c-.37-2.92-2.82-8.33-6-8.93a3.9,3.9,0,0,0-4.449,3.26,3.773,3.773,0,0,0-.041.41c-.19,2.31,1.49,4.63,3.12,6.09s5.58,2.79,6.95,3.23c-.24,1.14-.48,2.28-.76,3.36-.21.74-.36,1.47-.62,2.2l-.69,2.16c-.5,1.36-1,2.77-1.52,4.08-.35.92-.7,1.78-1,2.66.18-1.13.48-3.35.48-3.54a15,15,0,0,0-2-7.35,4.953,4.953,0,0,0-.06-.86,3.889,3.889,0,0,0-4.336-3.386,3.845,3.845,0,0,0-.424.076c-3.18.85-5.2,6.43-5.35,9.36,0,.18.11,2.07.2,3.26-.16-.69-.31-1.37-.48-2.08-.34-1.4-.71-2.8-1.11-4.3-.21-.72-.43-1.44-.66-2.17s-.51-1.48-.76-2.23c-.63-1.72-1.35-3.43-2.12-5.14,1.23-.29,5.59-1.4,7.34-2.75s3.58-3.52,3.57-5.84a3.9,3.9,0,0,0-3.786-4.011,3.755,3.755,0,0,0-.424.011c-3.27.36-6.11,5.57-6.7,8.45,0,.18-.23,2.29-.32,3.45-.46-1-.93-2.05-1.43-3.07-1.46-2.94-3-5.88-4.59-8.81-.48-.9-.94-1.8-1.41-2.7.44-.1,5.64-1.31,7.6-2.81,1.74-1.34,3.59-3.53,3.58-5.85a3.885,3.885,0,0,0-4.21-4c-3.27.35-6.11,5.56-6.71,8.44,0,.22-.31,3.26-.35,4-1-2-2-4-2.95-6a66.782,66.782,0,0,1-3.21-8.3c.2-.05,5.64-1.28,7.65-2.82,1.74-1.34,3.59-3.52,3.57-5.85a3.885,3.885,0,0,0-4.21-4c-3.27.35-6.11,5.56-6.7,8.44,0,.23-.34,3.5-.35,4.1-.05-.17-.12-.33-.17-.5a49.7,49.7,0,0,1-1.67-8.76c-.18-1.63-.26-3.2-.31-4.73,1-.13,5.77-.76,7.73-1.95s3.95-3.1,4.19-5.41a3.9,3.9,0,0,0-3.332-4.4,3.958,3.958,0,0,0-.408-.034c-3.3,0-6.69,4.86-7.6,7.66-.05.15-.38,1.75-.6,2.92v-2.07c0-2.49.16-4.76.32-6.78.09-1.15.21-2.18.32-3.15.95-.65,4.76-3.34,5.93-5.26s2.08-4.58,1.22-6.74a3.889,3.889,0,0,0-4.967-2.364,3.748,3.748,0,0,0-.393.164c-2.92,1.51-3.69,7.39-3.21,10.29.05.25,1.15,4.09,1.2,4.06h.06c-.13.93-.26,1.93-.38,3-.2,2-.4,4.3-.46,6.8a67.334,67.334,0,0,0,.19,8.06,51.012,51.012,0,0,0,1.49,8.91v.1c-.52-.81-2-3-2.18-3.19-1.92-2.23-6.94-5.39-10-4.1a3.9,3.9,0,0,0-1.918,5.171,3.954,3.954,0,0,0,.188.359c1.05,2.09,3.73,3.1,5.9,3.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40738",
    "data-name": "Path 40738",
    className: "cls-11",
    d: "M342.13,376.85s1-3.84,1.09-4.09c.4-2.91-.53-8.78-3.49-10.21a3.9,3.9,0,0,0-5.3,2.35c-.79,2.18.21,4.86,1.41,6.7,1.4,2.17,6.29,5.24,6.29,5.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40739",
    "data-name": "Path 40739",
    className: "cls-11",
    d: "M79.37,166.98H270.38a11.791,11.791,0,0,1,11.79,11.79V434.03a11.791,11.791,0,0,1-11.79,11.79H79.37a11.791,11.791,0,0,1-11.79-11.79V178.77a11.791,11.791,0,0,1,11.79-11.79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7831",
    "data-name": "Rectangle 7831",
    className: "cls-6",
    width: 194.05,
    height: 249.12,
    transform: "translate(77.85 183.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7832",
    "data-name": "Rectangle 7832",
    className: "cls-7",
    width: 194.05,
    height: 249.12,
    transform: "translate(77.85 183.47)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    className: "cls-7",
    x2: 78.81,
    transform: "translate(135.47 220.78)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    className: "cls-7",
    x2: 27.31,
    transform: "translate(224.56 254.73)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    className: "cls-7",
    x2: 72.07,
    transform: "translate(145.99 254.73)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    className: "cls-7",
    x2: 28.72,
    transform: "translate(112.4 254.73)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    className: "cls-7",
    x2: 7.48,
    transform: "translate(97.88 254.73)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    className: "cls-7",
    x2: 26.77,
    transform: "translate(225.1 281.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    className: "cls-7",
    x2: 39.02,
    transform: "translate(180.67 281.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    className: "cls-7",
    x2: 60.68,
    transform: "translate(114.03 281.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    className: "cls-7",
    x2: 9.1,
    transform: "translate(97.88 281.4)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    className: "cls-7",
    x2: 41.94,
    transform: "translate(209.93 308.08)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    className: "cls-7",
    x2: 82.36,
    transform: "translate(119.99 308.08)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    className: "cls-7",
    x2: 15.6,
    transform: "translate(97.88 308.08)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    className: "cls-7",
    x2: 9.97,
    transform: "translate(241.9 334.75)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    className: "cls-7",
    x2: 105.12,
    transform: "translate(126.49 334.75)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    className: "cls-7",
    x2: 21.02,
    transform: "translate(97.88 334.75)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    className: "cls-7",
    x2: 11.59,
    transform: "translate(240.28 361.43)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    className: "cls-7",
    x2: 81.82,
    transform: "translate(149.79 361.43)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    className: "cls-7",
    x2: 44.86,
    transform: "translate(97.88 361.43)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    className: "cls-7",
    x2: 52.23,
    transform: "translate(199.64 388.1)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    className: "cls-7",
    x2: 91.46,
    transform: "translate(97.88 388.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40740",
    "data-name": "Path 40740",
    className: "cls-6",
    d: "M200.43,161.35a5.24,5.24,0,0,1-4.28-8.19,18.39,18.39,0,1,0-31,.29,5.19,5.19,0,0,1-4.47,7.9h-32l8.64,24.82h86.41l8.64-24.82Zm-19.9-10.57a6.44,6.44,0,1,1,6.43-6.45v.02a6.43,6.43,0,0,1-6.43,6.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40741",
    "data-name": "Path 40741",
    className: "cls-7",
    d: "M200.43,161.35a5.24,5.24,0,0,1-4.28-8.19,18.39,18.39,0,1,0-31,.29,5.19,5.19,0,0,1-4.47,7.9h-32l8.64,24.82h86.41l8.64-24.82Zm-19.9-10.57a6.44,6.44,0,1,1,6.43-6.45v.02A6.43,6.43,0,0,1,180.53,150.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40742",
    "data-name": "Path 40742",
    className: "cls-11",
    d: "M101.571,379.1a22.22,22.22,0,1,1-1.513,31.387,22.219,22.219,0,0,1,1.513-31.387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40743",
    "data-name": "Path 40743",
    className: "cls-7",
    d: "M101.571,379.1a22.22,22.22,0,1,1-1.513,31.387A22.219,22.219,0,0,1,101.571,379.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40744",
    "data-name": "Path 40744",
    className: "cls-3",
    d: "M118.11,404.86a5,5,0,0,1-3.75-1.74l-9.75-11.4a5,5,0,1,1,7.57-6.49l6,7.06,20-22.32a5,5,0,1,1,7.871,6.169,5.1,5.1,0,0,1-.451.5l-23.84,26.55a5,5,0,0,1-3.71,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40745",
    "data-name": "Path 40745",
    className: "cls-11",
    d: "M141.99,369.83a3.48,3.48,0,0,1,2.59,5.82L120.74,402.2a3.436,3.436,0,0,1-5.2-.06l-9.8-11.42a3.49,3.49,0,0,1,5.211-4.644c.03.034.06.069.089.1l7.17,8.36,21.18-23.59a3.469,3.469,0,0,1,2.6-1.16m0-3h0a6.53,6.53,0,0,0-4.83,2.15l-18.9,21.05-4.94-5.76a6.49,6.49,0,1,0-10,8.272c.05.06.1.119.153.178l9.75,11.38a6.507,6.507,0,0,0,4.85,2.26h.08a6.462,6.462,0,0,0,4.82-2.15l23.85-26.55a6.5,6.5,0,0,0-4.83-10.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    className: "cls-7",
    y1: 62.08,
    transform: "translate(181.01 75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40746",
    "data-name": "Path 40746",
    className: "cls-12",
    d: "M178.17,63.4v5.79l-2.31,4a4.87,4.87,0,0,0,4.86,4.88h.02a4.87,4.87,0,0,0,4.87-4.87V69.19"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7833",
    "data-name": "Rectangle 7833",
    className: "cls-6",
    width: 9.76,
    height: 10.84,
    transform: "translate(173.14 52.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7834",
    "data-name": "Rectangle 7834",
    className: "cls-7",
    width: 9.76,
    height: 10.84,
    transform: "translate(173.14 52.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7835",
    "data-name": "Rectangle 7835",
    className: "cls-6",
    width: 16.98,
    height: 21.77,
    transform: "translate(169.54 37.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7836",
    "data-name": "Rectangle 7836",
    className: "cls-7",
    width: 16.98,
    height: 21.77,
    transform: "translate(169.54 37.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7837",
    "data-name": "Rectangle 7837",
    className: "cls-6",
    width: 26.92,
    height: 6.68,
    transform: "translate(164.48 48.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7838",
    "data-name": "Rectangle 7838",
    className: "cls-7",
    width: 26.92,
    height: 6.68,
    transform: "translate(164.48 48.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40747",
    "data-name": "Path 40747",
    className: "cls-11",
    d: "M178.02,48.67h3.86l5.45,6.18-.57.51h-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40748",
    "data-name": "Path 40748",
    className: "cls-11",
    d: "M189.28,48.67l2.12,2.39v4.3h-.07l-5.9-6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40749",
    "data-name": "Path 40749",
    className: "cls-11",
    d: "M170.62,48.67h3.85l5.45,6.18-.57.51h-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40750",
    "data-name": "Path 40750",
    className: "cls-11",
    d: "M164.47,50.11V48.67h2.59l5.45,6.18-.57.51H169.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    className: "cls-13",
    y1: 13.1,
    transform: "translate(178.41 24.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40751",
    "data-name": "Path 40751",
    className: "cls-13",
    d: "M1,23.93H185.21V16.08L149.6,1H1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40752",
    "data-name": "Path 40752",
    className: "cls-13",
    d: "M149.6,23.93V1L126.07,23.93V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40753",
    "data-name": "Path 40753",
    className: "cls-13",
    d: "M126.1,23.93V1L102.56,23.93V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40754",
    "data-name": "Path 40754",
    className: "cls-13",
    d: "M102.59,23.93V1L79.06,23.93V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40755",
    "data-name": "Path 40755",
    className: "cls-13",
    d: "M79.09,23.93V1L55.55,23.93V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40756",
    "data-name": "Path 40756",
    className: "cls-13",
    d: "M55.58,23.93V1L32.05,23.93V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40757",
    "data-name": "Path 40757",
    className: "cls-13",
    d: "M32.08,23.93V1L8.54,23.93V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40758",
    "data-name": "Path 40758",
    className: "cls-6",
    d: "M391.45,257.15l-12.38,34.17-.79-.2-7-5.07-2.59,2.55,2.72,13.37s11,5.66,13,5.29a28.866,28.866,0,0,0,4.38-1.27s6.92-47.56,7.1-48.48-.98-3.46-4.44-.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40759",
    "data-name": "Path 40759",
    className: "cls-7",
    d: "M391.45,257.15l-12.38,34.17-.79-.2-7-5.07-2.59,2.55,2.72,13.37s11,5.66,13,5.29a28.866,28.866,0,0,0,4.38-1.27s6.92-47.56,7.1-48.48S394.91,254.05,391.45,257.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40760",
    "data-name": "Path 40760",
    className: "cls-6",
    d: "M394.79,435.72s-3.46,5.27-6.28,7.49-9.44,5.42-11.28,6.91-1,2.82-.39,3.46,9.15,1.11,13.78,1.12,13-2,13-2,3.7.59,4.64.12,1.53-1.52,1.68-3.16-.39-10.9-.39-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40761",
    "data-name": "Path 40761",
    className: "cls-7",
    d: "M394.79,435.72s-3.46,5.27-6.28,7.49-9.44,5.42-11.28,6.91-1,2.82-.39,3.46,9.15,1.11,13.78,1.12,13-2,13-2,3.7.59,4.64.12,1.53-1.52,1.68-3.16-.39-10.9-.39-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40762",
    "data-name": "Path 40762",
    className: "cls-11",
    d: "M404.73,450.25c-3.6.58-4.31,1.4-11.29,2.44-5.74.86-14.25-.2-17.34-.75a2.24,2.24,0,0,0,.74,1.62c.63.64,9.15,1.11,13.78,1.12s13-2,13-2,3.7.59,4.64.12,1.52-1.51,1.67-3.12a45.369,45.369,0,0,0-5.2.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40763",
    "data-name": "Path 40763",
    className: "cls-7",
    d: "M404.73,450.25c-3.6.58-4.31,1.4-11.29,2.44-5.74.86-14.25-.2-17.34-.75a2.24,2.24,0,0,0,.74,1.62c.63.64,9.15,1.11,13.78,1.12s13-2,13-2,3.7.59,4.64.12,1.52-1.51,1.67-3.12A45.369,45.369,0,0,0,404.73,450.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40764",
    "data-name": "Path 40764",
    className: "cls-13",
    d: "M397.8,439.59s-4-1.78-6.7,1.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40765",
    "data-name": "Path 40765",
    className: "cls-13",
    d: "M393.24,438.08s3.08,2.41,2.67,5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40766",
    "data-name": "Path 40766",
    className: "cls-13",
    d: "M394.81,442.37s-3.15-1.46-5.29,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40767",
    "data-name": "Path 40767",
    className: "cls-13",
    d: "M391.22,441.14s2.42,2,2.08,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40768",
    "data-name": "Path 40768",
    className: "cls-13",
    d: "M392.53,445.19s-2.91-1.37-7.49.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40769",
    "data-name": "Path 40769",
    className: "cls-13",
    d: "M388.85,443.94a2.05,2.05,0,0,1-.013,2.9,2.012,2.012,0,0,1-.387.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40770",
    "data-name": "Path 40770",
    className: "cls-6",
    d: "M417.6,440.72s-1.71,6.12-2.32,7-4.69,6-4.73,7.79,1.27,3.17,4.52,3.91,8.29,1,12.31-.83,5.83-2.43,6.84-5.23.34-12.19.34-12.19-12.55-9.25-16.96-.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40771",
    "data-name": "Path 40771",
    className: "cls-7",
    d: "M417.6,440.72s-1.71,6.12-2.32,7-4.69,6-4.73,7.79,1.27,3.17,4.52,3.91,8.29,1,12.31-.83,5.83-2.43,6.84-5.23.34-12.19.34-12.19S422.01,431.92,417.6,440.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40772",
    "data-name": "Path 40772",
    className: "cls-11",
    d: "M434.22,453.33a17.359,17.359,0,0,0,.54-4.65,30.308,30.308,0,0,1-2.82,3.79c-2,2.19-5.38,4.62-11.9,5.1a13,13,0,0,1-9.32-2.86,3.033,3.033,0,0,0-.17.77c0,1.83,1.27,3.17,4.52,3.91s8.29,1,12.31-.83,5.83-2.43,6.84-5.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40773",
    "data-name": "Path 40773",
    className: "cls-7",
    d: "M434.22,453.33a17.359,17.359,0,0,0,.54-4.65,30.308,30.308,0,0,1-2.82,3.79c-2,2.19-5.38,4.62-11.9,5.1a13,13,0,0,1-9.32-2.86,3.033,3.033,0,0,0-.17.77c0,1.83,1.27,3.17,4.52,3.91s8.29,1,12.31-.83S433.21,456.13,434.22,453.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40774",
    "data-name": "Path 40774",
    className: "cls-13",
    d: "M426.43,438.64s-5.48-.27-7.2,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40775",
    "data-name": "Path 40775",
    className: "cls-13",
    d: "M420.43,438.72s4.71,1,5.43,3.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40776",
    "data-name": "Path 40776",
    className: "cls-13",
    d: "M425.34,442.64s-5.49-.26-7.21,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40777",
    "data-name": "Path 40777",
    className: "cls-13",
    d: "M419.33,442.72s4.71,1,5.44,3.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40778",
    "data-name": "Path 40778",
    className: "cls-13",
    d: "M424.25,446.64s-5.49-.26-7.21,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40779",
    "data-name": "Path 40779",
    className: "cls-13",
    d: "M418.24,446.72s4.71,1,5.43,3.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40780",
    "data-name": "Path 40780",
    className: "cls-11",
    d: "M384.79,320.58s2.1,31.81,3,40.74,3.09,29.52,3.27,30.07.73,7.83.73,7.83-.54,2.92.19,9.3,2.91,19.68,2.91,19.68-1.82.36-1.64,1.82.91,5.47.91,5.47,6.93,2.36,8.93,2.55a59.25,59.25,0,0,0,6,0s1.64-2.74,1.46-4.19a44.873,44.873,0,0,0-1.46-5.29l.91-10.75,1.53-43.91s5.65,42.82,6.56,45.91,1.82,8,1.82,8-1.82,1.46-1.82,2.37.37,7.29.37,7.29,3.64-2.92,7.1-2.37,9.12,4.56,9.12,4.56a36.647,36.647,0,0,1,1.09-5.47c.73-2.37-.73-8.38-1.1-10a14.942,14.942,0,0,1-.18-5.65c.37-1.64.55-6.74.73-8.38s-.18-42.46-.18-42.46l3.72-46.75-53-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40781",
    "data-name": "Path 40781",
    className: "cls-7",
    d: "M384.79,320.58s2.1,31.81,3,40.74,3.09,29.52,3.27,30.07.73,7.83.73,7.83-.54,2.92.19,9.3,2.91,19.68,2.91,19.68-1.82.36-1.64,1.82.91,5.47.91,5.47,6.93,2.36,8.93,2.55a59.25,59.25,0,0,0,6,0s1.64-2.74,1.46-4.19a44.873,44.873,0,0,0-1.46-5.29l.91-10.75,1.53-43.91s5.65,42.82,6.56,45.91,1.82,8,1.82,8-1.82,1.46-1.82,2.37.37,7.29.37,7.29,3.64-2.92,7.1-2.37,9.12,4.56,9.12,4.56a36.647,36.647,0,0,1,1.09-5.47c.73-2.37-.73-8.38-1.1-10a14.942,14.942,0,0,1-.18-5.65c.37-1.64.55-6.74.73-8.38s-.18-42.46-.18-42.46l3.72-46.75-53-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40782",
    "data-name": "Path 40782",
    className: "cls-3",
    d: "M404.21,242.16s-11.26,5.16-12,7-4.54,39.1-6.73,54-1.25,18.86-1.25,18.86,2.35,4.85,25.34,4.06,31.13-4.22,31.44-6.25.63.54.63-.87,1.72-67.88,0-71.95-11.42-10.79-14.24-11.1-23.19,6.25-23.19,6.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40783",
    "data-name": "Path 40783",
    className: "cls-7",
    d: "M404.21,242.16s-11.26,5.16-12,7-4.54,39.1-6.73,54-1.25,18.86-1.25,18.86,2.35,4.85,25.34,4.06,31.13-4.22,31.44-6.25.63.54.63-.87,1.72-67.88,0-71.95-11.42-10.79-14.24-11.1S404.21,242.16,404.21,242.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40784",
    "data-name": "Path 40784",
    className: "cls-6",
    d: "M422.8,239.12c-6.88,1.69-18.59,5.47-18.59,5.47s-11.26,5.16-12,7a22.434,22.434,0,0,0-.55,3.13c5-2.84,16.69-9.44,20.63-10.68a50.9,50.9,0,0,1,9.85-2l13.01,8.68,5.46.14s-12.25-10.79-15.71-11.72a7.21,7.21,0,0,0-2.1-.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40785",
    "data-name": "Path 40785",
    className: "cls-7",
    d: "M422.8,239.12c-6.88,1.69-18.59,5.47-18.59,5.47s-11.26,5.16-12,7a22.434,22.434,0,0,0-.55,3.13c5-2.84,16.69-9.44,20.63-10.68a50.9,50.9,0,0,1,9.85-2l13.01,8.68,5.46.14s-12.25-10.79-15.71-11.72A7.21,7.21,0,0,0,422.8,239.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40786",
    "data-name": "Path 40786",
    className: "cls-6",
    d: "M385.47,305.41v.18c-.38,2.59-.64,4.92-.83,7.05a142.61,142.61,0,0,0,35.1,2.66c12-.73,18.66-1.17,22.05-1.39,0-2.05.09-4.43.14-7.06-8.02.87-39.32,3.58-56.46-1.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40787",
    "data-name": "Path 40787",
    className: "cls-7",
    d: "M385.47,305.41v.18c-.38,2.59-.64,4.92-.83,7.05a142.61,142.61,0,0,0,35.1,2.66c12-.73,18.66-1.17,22.05-1.39,0-2.05.09-4.43.14-7.06C433.91,307.72,402.61,310.43,385.47,305.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40788",
    "data-name": "Path 40788",
    className: "cls-14",
    d: "M393.69,317.88c.08,1.42.2,2.8.35,4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40789",
    "data-name": "Path 40789",
    className: "cls-14",
    d: "M397.11,284.9c-1.58,9.44-3.75,18.82-3.53,29.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40790",
    "data-name": "Path 40790",
    className: "cls-14",
    d: "M399.99,272.9s-1.17,4.88-2.47,12.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40791",
    "data-name": "Path 40791",
    className: "cls-6",
    d: "M364.81,326.33s2.3,4.08,6.39-.46c2.2-2.43,10.47-27.68,10.47-27.68s-16.14,25.53-16.86,28.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40792",
    "data-name": "Path 40792",
    className: "cls-7",
    d: "M364.81,326.33s2.3,4.08,6.39-.46c2.2-2.43,10.47-27.68,10.47-27.68S365.53,323.72,364.81,326.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40793",
    "data-name": "Path 40793",
    className: "cls-6",
    d: "M349.37,250l10.72-3.71s-.11,23,1.45,28.47l1.55,5.49s-10.42-17.38-12.65-23.18-1.07-7.07-1.07-7.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40794",
    "data-name": "Path 40794",
    className: "cls-7",
    d: "M349.37,250l10.72-3.71s-.11,23,1.45,28.47l1.55,5.49s-10.42-17.38-12.65-23.18S349.37,250,349.37,250Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40795",
    "data-name": "Path 40795",
    className: "cls-6",
    d: "M371.53,283.35s-1.9-5.25-5.15-4.17-5.64,1-5.89,2.45,8.2,7,8.2,7,5.99-.38,2.84-5.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40796",
    "data-name": "Path 40796",
    className: "cls-7",
    d: "M371.53,283.35s-1.9-5.25-5.15-4.17-5.64,1-5.89,2.45,8.2,7,8.2,7S374.68,288.25,371.53,283.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40797",
    "data-name": "Path 40797",
    className: "cls-6",
    d: "M375.53,308.14s-10.56,17.47-10.7,18.19c0,0-7.24-12.26-17-27.28s-18.94-50.54-18.94-50.54a17.547,17.547,0,0,1,10.42-5.07c6.86-.92,9.22-.65,9.22-.65s6.54,23.13,13.78,33.79a118.505,118.505,0,0,0,16.41,18.9l3,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40798",
    "data-name": "Path 40798",
    className: "cls-7",
    d: "M375.53,308.14s-10.56,17.47-10.7,18.19c0,0-7.24-12.26-17-27.28s-18.94-50.54-18.94-50.54a17.547,17.547,0,0,1,10.42-5.07c6.86-.92,9.22-.65,9.22-.65s6.54,23.13,13.78,33.79a118.505,118.505,0,0,0,16.41,18.9l3,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40799",
    "data-name": "Path 40799",
    className: "cls-14",
    d: "M347.61,279.46a188.561,188.561,0,0,0,19.13,5.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40800",
    "data-name": "Path 40800",
    className: "cls-14",
    d: "M341.76,277.3s.84.33,2.26.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40801",
    "data-name": "Path 40801",
    className: "cls-14",
    d: "M352.21,275.03s6.85,6.87,14,8.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40802",
    "data-name": "Path 40802",
    className: "cls-6",
    d: "M387.15,292.66s-8.76-4.07-10.17-4.22-8.6,2.65-9.38,3.28-1.1,2-.16,2.19,2.5-.94,2.5-.94l4.07-.78,1.88,1.09s-6.57,3.91-7.2,5.17-1.72,3.59-1.09,4.06.94,1.57,1.87,1.57a9.054,9.054,0,0,0,1.48-.1,6.607,6.607,0,0,0,3.22-1.47c1.4-1.25,4.53-.78,4.53-.78s3.76,1.25,4.7.94a27.96,27.96,0,0,0,3.28-1.72h1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40803",
    "data-name": "Path 40803",
    className: "cls-7",
    d: "M387.15,292.66s-8.76-4.07-10.17-4.22-8.6,2.65-9.38,3.28-1.1,2-.16,2.19,2.5-.94,2.5-.94l4.07-.78,1.88,1.09s-6.57,3.91-7.2,5.17-1.72,3.59-1.09,4.06.94,1.57,1.87,1.57a9.054,9.054,0,0,0,1.48-.1,6.607,6.607,0,0,0,3.22-1.47c1.4-1.25,4.53-.78,4.53-.78s3.76,1.25,4.7.94a27.96,27.96,0,0,0,3.28-1.72h1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40804",
    "data-name": "Path 40804",
    className: "cls-14",
    d: "M367.6,302.51s3.35-3.49,3.73-3.94,6.06-3.31,6.06-3.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40805",
    "data-name": "Path 40805",
    className: "cls-14",
    d: "M369.47,304.08s4.54-4,4.86-4.24,4.14-1.78,4.14-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40806",
    "data-name": "Path 40806",
    className: "cls-6",
    d: "M439.25,249.59s-6.1-2-10.32,4.54-6.75,38.2-6.75,38.2l-35,.33.62,9.7s33.16,3.58,39.57,3.58,8.14,1.09,8.92-1.25,7.68-30.85,8.62-39.92-2.69-14.55-5.66-15.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40807",
    "data-name": "Path 40807",
    className: "cls-7",
    d: "M439.25,249.59s-6.1-2-10.32,4.54-6.75,38.2-6.75,38.2l-35,.33.62,9.7s33.16,3.58,39.57,3.58,8.14,1.09,8.92-1.25,7.68-30.85,8.62-39.92S442.22,250.22,439.25,249.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40808",
    "data-name": "Path 40808",
    className: "cls-11",
    d: "M387.53,321.13s-9.66-1.46-10.21-.37,0,16,.91,16.95,7.11,2.19,8.93,1.09,2.92-1.82,3.28-2.73.37-12.39-.36-13.85a2.4,2.4,0,0,0-2.55-1.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40809",
    "data-name": "Path 40809",
    className: "cls-7",
    d: "M387.53,321.13s-9.66-1.46-10.21-.37,0,16,.91,16.95,7.11,2.19,8.93,1.09,2.92-1.82,3.28-2.73.37-12.39-.36-13.85A2.4,2.4,0,0,0,387.53,321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40810",
    "data-name": "Path 40810",
    className: "cls-11",
    d: "M399,322.95s-1.47,14.77.91,15.67a25.382,25.382,0,0,0,8.2,1.1c.91-.19,4.19-.73,4.74-2.19s.54-12.94.18-14-13.12-2.04-14.03-.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40811",
    "data-name": "Path 40811",
    className: "cls-7",
    d: "M399,322.95s-1.47,14.77.91,15.67a25.382,25.382,0,0,0,8.2,1.1c.91-.19,4.19-.73,4.74-2.19s.54-12.94.18-14S399.91,321.49,399,322.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40812",
    "data-name": "Path 40812",
    className: "cls-11",
    d: "M421.96,324.59s.73,16.58,1.09,17.31,7.29,5.29,8.56,5.1,11.48-1.27,12-3.28,1.82-18.22.73-20-3.46-2.55-5.65-2.73-14.94,1.64-14.94,1.64a1.94,1.94,0,0,0-1.79,1.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40813",
    "data-name": "Path 40813",
    className: "cls-7",
    d: "M421.96,324.59s.73,16.58,1.09,17.31,7.29,5.29,8.56,5.1,11.48-1.27,12-3.28,1.82-18.22.73-20-3.46-2.55-5.65-2.73-14.94,1.64-14.94,1.64A1.94,1.94,0,0,0,421.96,324.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40814",
    "data-name": "Path 40814",
    className: "cls-11",
    d: "M408.91,238.02l-7.51,4.07,2.66,4.85L400.3,270.4s22.23-28.94,22.53-29.41a36.96,36.96,0,0,1,4.53-2.66l-1.41-5.79-2.34.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40815",
    "data-name": "Path 40815",
    className: "cls-7",
    d: "M408.91,238.02l-7.51,4.07,2.66,4.85L400.3,270.4s22.23-28.94,22.53-29.41a36.96,36.96,0,0,1,4.53-2.66l-1.41-5.79-2.34.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40816",
    "data-name": "Path 40816",
    className: "cls-6",
    d: "M400.98,205.72s-1.35,4.17-1.35,4.73a20.084,20.084,0,0,0,.34,2.25s-4.16,5.85-3.94,6.18,2.7,2.93,2.7,2.93.22,8.77,1.35,8.89,8.44.11,8.44.11l-.68,12.82,16.76-9.67.34-11.25s4.5-5.74,4.5-8.66-.45-3.49-.45-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40817",
    "data-name": "Path 40817",
    className: "cls-7",
    d: "M400.98,205.72s-1.35,4.17-1.35,4.73a20.084,20.084,0,0,0,.34,2.25s-4.16,5.85-3.94,6.18,2.7,2.93,2.7,2.93.22,8.77,1.35,8.89,8.44.11,8.44.11l-.68,12.82,16.76-9.67.34-11.25s4.5-5.74,4.5-8.66-.45-3.49-.45-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40818",
    "data-name": "Path 40818",
    className: "cls-11",
    d: "M428.99,210.55l-17.91-3.09.14,1.29-.68,6.19s4.72-3.26,5.62-3.71,2.7,2.7,1.69,4.61-4.39,4.5-4.39,4.5,3.72,3.82,7.54,4a13.6,13.6,0,0,0,3.9-.32v-1.37s4.5-5.74,4.5-8.66-.41-3.44-.41-3.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40819",
    "data-name": "Path 40819",
    className: "cls-7",
    d: "M428.99,210.55l-17.91-3.09.14,1.29-.68,6.19s4.72-3.26,5.62-3.71,2.7,2.7,1.69,4.61-4.39,4.5-4.39,4.5,3.72,3.82,7.54,4a13.6,13.6,0,0,0,3.9-.32v-1.37s4.5-5.74,4.5-8.66S428.99,210.55,428.99,210.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40820",
    "data-name": "Path 40820",
    className: "cls-14",
    d: "M400.75,210.1a2.66,2.66,0,0,1,3.38.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40821",
    "data-name": "Path 40821",
    className: "cls-11",
    d: "M401.88,211.79c.309,0,.56.6.56,1.35s-.251,1.35-.56,1.35-.56-.6-.56-1.35.251-1.35.56-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40822",
    "data-name": "Path 40822",
    className: "cls-11",
    d: "M405.37,230.57l6.86-.79-3.71,4.39V230.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40823",
    "data-name": "Path 40823",
    className: "cls-14",
    d: "M405.37,230.57l6.86-.79-3.71,4.39V230.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40824",
    "data-name": "Path 40824",
    className: "cls-6",
    d: "M418.64,212.24l6.26,11.83,2.96-2.83-5.62-9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40825",
    "data-name": "Path 40825",
    className: "cls-7",
    d: "M418.64,212.24l6.26,11.83,2.96-2.83-5.62-9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40826",
    "data-name": "Path 40826",
    className: "cls-3",
    d: "M398.77,203.02s-7.93,1-6.95,1.36,41.92,12.94,41.92,12.94a26.079,26.079,0,0,1-.82-3.93c0-1,1.64-7.37,1-13.92s-14.5-10.21-21.37-10.86-10.32,2.62-11,6.22a42.05,42.05,0,0,1-2.78,8.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40827",
    "data-name": "Path 40827",
    className: "cls-7",
    d: "M398.77,203.02s-7.93,1-6.95,1.36,41.92,12.94,41.92,12.94a26.079,26.079,0,0,1-.82-3.93c0-1,1.64-7.37,1-13.92s-14.5-10.21-21.37-10.86-10.32,2.62-11,6.22A42.05,42.05,0,0,1,398.77,203.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40828",
    "data-name": "Path 40828",
    className: "cls-7",
    d: "M410.13,206.45l-7.23-2.6s4.2-9.55,4.05-10.71a20.18,20.18,0,0,1-.14-2.17s.14-1.88,6.51-1.15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPolicyImg);
export default __webpack_public_path__ + "static/media/project_policy_Img.8ae0fb01d1a83a6d525e3ee41624ea81.svg";
export { ForwardRef as ReactComponent };